import { useExamLocationRequestDetails as useExamLocationRequestDetailsFromProvider } from '../../providers/exam-location-request-details-provider/exam-location-request-details-provider';

/**
 * useExamLocationRequestDetails
 *
 * Thin re-export wrapper around the provider hook. Centralizing this in /hooks
 * allows consumers to have a consistent import path for all hooks in the
 * exam-location-management library, instead of importing directly from the
 * providers directory.
 *
 * Usage:
 *   const { examLocationRequestInfo } = useExamLocationRequestDetails();
 *
 * Requires that the component is rendered inside
 * <ExamLocationRequestDetailsProvider examLocationRequestInfoId={...}>.
 */
export function useExamLocationRequestDetails() {
  return useExamLocationRequestDetailsFromProvider();
}

export default useExamLocationRequestDetails;
